const packages = {
  Platinum: {
    name: 'Platinum',
    color: '#0e0e0e',
    gradientFill1: null,
    gradientFill2: null,
    layout: 'layout1',
  },
  Gold: {
    name: 'Gold',
    color: null,
    gradientFill1: '#9f7433',
    gradientFill2: '#f5dc54',
    layout: 'layout1',
  },
  Silver: {
    name: 'Silver',
    color: null,
    gradientFill1: '#a0a0a0',
    gradientFill2: '#ececec',
    layout: 'layout2',
  },
  Bronze: {
    name: 'Bronze',
    color: null,
    gradientFill1: '#92613b',
    gradientFill2: '#cfa681',
    layout: 'layout2',
  },
  'Bronze Plus': {
    name: 'Bronze',
    color: null,
    gradientFill1: '#92613b',
    gradientFill2: '#cfa681',
    type: 'bronzePlus',
    layout: 'layout2',
  },
  'Bronze Standard': {
    name: 'Bronze',
    color: null,
    gradientFill1: '#92613b',
    gradientFill2: '#cfa681',
    type: 'bronzeStandard',
    layout: 'layout2',
  },
  'Bronze Basic': {
    name: 'Bronze',
    color: null,
    gradientFill1: '#92613b',
    gradientFill2: '#cfa681',
    type: 'bronzeBasic',
    layout: 'layout2',
  },
  'Bronze Free': {
    name: 'Bronze',
    color: null,
    gradientFill1: '#92613b',
    gradientFill2: '#cfa681',
    type: 'bronzeFree',
    layout: 'layout2',
  },
  Paid: {
    layout: 'layout2',
  },
  'Free Package': {
    layout: 'layout2',
  },
  'Non Client': {
    layout: 'layout3',
  },
};

const getPackageLayout = packageName => {
  return packages[packageName] || packages['Non Client'];
};

export default getPackageLayout;
